import { IsNotEmpty, IsUUID } from 'class-validator';

export class GetHashesHashDto {
  @IsUUID()
  @IsNotEmpty()
  event_id: string;
}
